import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-标准化证明",
  "use": "icon-标准化证明-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-标准化证明\">\n<style type=\"text/css\">\n\t#icon-标准化证明 .st0{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t#icon-标准化证明 .st1{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n</style>\n<path d=\"M11.2,4.4H4.5c-0.5,0-0.9,0.4-0.9,1v5.3c0,0.6,0.4,1,0.9,1h6.7c0.5,0,0.9-0.4,0.9-1V5.4C12.1,4.8,11.7,4.4,11.2,4.4z\n\t M7.8,11.4c-0.2,0-0.4-0.2-0.4-0.5c0-0.3,0.2-0.5,0.4-0.5c0.2,0,0.4,0.2,0.4,0.5C8.3,11.2,8.1,11.4,7.8,11.4z M11.4,10.1H4.3v-5h7.2\n\tL11.4,10.1L11.4,10.1z M9.4,12.1H6.3c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.2,0.4,0.3,0.4h3.1c0.2,0,0.3-0.2,0.3-0.4\n\tC9.7,12.3,9.6,12.1,9.4,12.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/标准化证明.svg
// module id = D219
// module chunks = 166